var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":"success","title":"This feature is still under development. Please let us know what you think of it!"}},[_vm._v(" beta ")])}
var staticRenderFns = []

export { render, staticRenderFns }